// extracted by mini-css-extract-plugin
export default {"desc":"Description_desc__9qMOx","wide":"Description_wide__lfMkk"};